import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import LinkBack from '../widgets/LinkBack';

import './news-block.scss';

export class NewsSecondary extends PureComponent {
  render() {
    if (!this.props.post) {
      return null;
    }

    return (
      <Link
        className="news-secondary"
        to={`${this.props.pathname}${this.props.post.id}/`}
      >
        <div className="news-secondary-content">
          <span className="news-secondary-date">
            {this.props.post.dateDisplay}
          </span>

          <h2
            className="news-secondary-title"
            dangerouslySetInnerHTML={{ __html: this.props.post.title }}
          />

          <p
            className="news-secondary-text"
            dangerouslySetInnerHTML={{ __html: this.props.post.previewText }}
          />

          <div className="news-secondary-button">
            <div className="btn btn-arrowed">
              Подробнее <span className="icon">→</span>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

NewsSecondary.propTypes = {
  pathname: PropTypes.string.isRequired,
  post: PropTypes.shape({
    id: PropTypes.number,
    datePublished: PropTypes.string,
    title: PropTypes.string,
    previewText: PropTypes.string
  })
};

class NewsItem extends PureComponent {
  render() {
    return (
      <div className="news-item">
        <span className="news-item-date">{this.props.dateDisplay}</span>

        <Link
          to={`${this.props.pathname}${this.props.id}/`}
          dangerouslySetInnerHTML={{ __html: this.props.title }}
        />
      </div>
    );
  }
}

NewsItem.propTypes = {
  id: PropTypes.number,
  date: PropTypes.string,
  title: PropTypes.string,
  pathname: PropTypes.string.isRequired
};

class NewsList extends PureComponent {
  render() {
    const leftCol = this.props.posts.slice(0, 4);
    const rightCol = this.props.posts.slice(4, 8);

    return (
      <div className="last-news">
        <div className="last-news-row">
          <ul className="last-news-col">
            {leftCol.map(item =>
              <li key={item.id}>
                <NewsItem
                  {...item}
                  pathname={this.props.pathname}
                />
              </li>
            )}
          </ul>
          <ul className="last-news-col">
            {rightCol.map(item =>
              <li key={item.id}>
                <NewsItem
                  {...item}
                  pathname={this.props.pathname}
                />
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

NewsList.propTypes = {
  pathname: PropTypes.string.isRequired,
  posts: PropTypes.arrayOf(PropTypes.object)
};

const contentDict = {
  '/analyze/actually/': {
    title: 'Публикации'
  },
  '/we/news/': {
    title: 'Все новости'
  }
};

class NewsBlock extends PureComponent {
  render() {
    const content = contentDict[this.props.pathname];

    return (
      <div className="news-block">
        <NewsSecondary
          pathname={this.props.pathname}
          post={this.props.secondaryPost}
        />

        {(!!this.props.posts.length) &&
          <NewsList
            pathname={this.props.pathname}
            posts={this.props.posts}
          />
        }

        {(!this.props.listView) &&
          <div className="news-block-posts">
            <LinkBack
              direction="right"
              link={`${this.props.pathname}?list`}
            >
              {content.title} <i>архив</i>
            </LinkBack>
          </div>
        }
      </div>
    );
  }
}

NewsBlock.propTypes = {
  pathname: PropTypes.string.isRequired,
  secondaryPost: PropTypes.object,
  posts: PropTypes.arrayOf(PropTypes.object),
  listView: PropTypes.bool
};

export default NewsBlock;



// WEBPACK FOOTER //
// ./src/components/News/NewsBlock.js